<div class="container m-20">
    <table id="actionPlanRef" #actionPlanRef class="table d-none">
        <tr class="content border">
            <td class="border">Action Plan Name</td>
            <td class="border">{{ actionPlan.actionPlanName }}</td>
            <td class="border">Action Plan Name (Arabic)</td>
            <td class="border" dir="rtl" lang="ar">
                {{ actionPlan.actionPlanNameArabic }}
            </td>
        </tr>
        <tr class="content border">
            <!-- <td class="border">Action Plan ID</td>
            <td class="border">{{ actionPlan.actionId }}</td> -->
            <td class="border">Assessment Name</td>
            <td class="border">{{ actionPlan.assessmentName }}</td>
            <td class="border">Assessment Entity Name</td>
            <td class="border">{{ actionPlan.assessmentUnitName }}</td>
        </tr>
        <tr class="content border">
            <td class="border">Action Plan Start Date</td>
            <td class="border">{{ actionPlan.startDate | date:"dd/MM/yyyy" }}</td>
            <td class="border">Action Plan Target Date</td>
            <td class="border">{{ actionPlan.endDate | date:"dd/MM/yyyy"}}</td>
        </tr>
        <tr class="content border">
            <td class="border">Action Plan Description</td>
            <td class="border">{{ actionPlan.actionPlanDescription }}</td>
            <td class="border">Action Plan Description (Arabic)</td>
            <td class="border" dir="rtl" lang="ar">
                {{ actionPlan.actionPlanDescriptionArabic }}
            </td>
            <!-- <td class="border">Assessment Name</td>
            <td class="border">{{ data.AssessmentName }}</td> -->
        </tr>
    </table>
    <div id="actionItemTablesContainerRef" #actionItemTablesContainerRef>
        <ng-container *ngFor="let actionItem of actionItemsList;let idx = index">
            <table [id]="'actionItemRef'+idx" #actionItemRef+idx class="table d-none">
                <tr class="content border">
                    <td class="border">Serial Number</td>
                    <td class="border">{{ idx+1 }}</td>
                    <td class="border">Action Item ID</td>
                    <td class="border">{{ actionItem.actionId }}</td>
                </tr>
                <tr class="content border">
                    <td class="border">Action Item Name</td>
                    <td class="border">{{ actionItem.actionItemName }}</td>
                    <td class="border">Action Item Name (Arabic)</td>
                    <td class="border" dir="rtl" lang="ar">
                        {{ actionItem.actionItemNameArabic }}
                    </td>
                </tr>
                <tr class="content border">
                    <td class="border">Action Item Description</td>
                    <td class="border">{{ actionItem.actionItemDescription }}</td>
                    <td class="border">Action Item Description (Arabic)</td>
                    <td class="border" dir="rtl" lang="ar">
                        {{ actionItem.actionItemDescriptionArabic }}
                    </td>

                </tr>
                <tr class="content border">
                    <td class="border">Action Item Status</td>
                    <td class="border" dir="rtl" lang="ar">
                        {{ actionItem.actionItemStatus }}
                    </td>
                    <td class="border">Criticality</td>
                    <td class="border">{{ actionItem.criticality }}</td>


                </tr>
                <tr class="content border">
                    <td class="border">Action Category</td>
                    <td class="border">{{ actionItem.actionCategory }}</td>
                    <td class="border">Action Item Start Date</td>
                    <td class="border">{{ actionItem.creationDate | date:"dd/MM/yyyy" }}</td>

                </tr>
                <tr class="content border">
                    <td class="border">Action Item Target Date</td>
                    <td class="border">{{ actionItem.targetCompletionDate | date:"dd/MM/yyyy"}}</td>
                    <td class="border">Actual Completion Date</td>
                    <td class="border">{{ actionItem.actualCompletionDate | date:"dd/MM/yyyy" }}</td>

                </tr>
                <tr class="content border">
                    <td class="border">Comments History</td>
                    <td class="border">
                        <ng-container *ngIf="actionItem.commentHistory && actionItem.commentHistory.length>0">
                            <ng-container *ngFor="let cmt of actionItem.commentHistory">
                                <pre>{{ cmt }}</pre>
                                <br>
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </table>
        </ng-container>
    </div>
</div>